import Vue from 'vue';
import * as utils from '../utils';

export default {
  name: 'Times',
  props: ['propTime'],
  data: function () {
    return {
      time: { hours: 0, minutes: 0, descr: '', isReadOnly: false },
      message: '',
    }
  },
  watch: {
    "time.minutes": function (value) {
      if (value > 60 || value < 0) {
        this.$alertMsg(this.$t('common.DateMinutesError'), 3);
        this.time.minutes = 0;
      }
    },
    "time.hours": function (value) {
      if (value > 24 || value < 0) {
        this.$alertMsg(this.$t('common.DateHoursError'), 3);
        this.time.hours = 0;
      }
    },
  },
  computed: {
    hoursValue: function () { return this.time.hours; },
	minutesValue: function () { return this.time.minutes; },
    timeDescr: function () {
      return this.time.descr && this.time.descr != '' ? this.time.descr : 'Time';
    },
  },
  created() {
    this.time = this.propTime;
  }
}
